import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import { CurrencyProvider } from "@/contexts/CurrencyContext";
import Home from "@/pages/Home";
import { WorkIndex, WorkCategory } from "@/pages/Work";
import ArtworkDetail from "@/pages/ArtworkDetail";
import Collections from "@/pages/Collections";
import CollectionDetail from "@/pages/CollectionDetail";
import Commissions from "@/pages/Commissions";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import { Prints } from "@/pages/Prints";
import Press from "@/pages/Press";
import Services from "@/pages/Services";
import StudioVisit from "@/pages/StudioVisit";
import Collectors from "@/pages/Collectors";
import CVPage from "@/pages/CV";
import Books from "@/pages/Books";
import Murals from "@/pages/Murals";
import PaintNSip from "@/pages/PaintNSip";
import LivePainting from "@/pages/LivePainting";
import Trade from "@/pages/Trade";
import FAQPage from "@/pages/FAQ";
import { Journal, JournalPost } from "@/pages/Journal";
import Originals from "@/pages/Originals";
import Shop from "@/pages/Shop";
import YouthArtClasses from "@/pages/YouthArtClasses";
import YouthRegister from "@/pages/YouthRegister";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const scroll = () => {
        const el = document.getElementById(hash.slice(1));
        if (el) el.scrollIntoView({ block: "start" });
      };
      scroll();
      const t1 = setTimeout(scroll, 300);
      const t2 = setTimeout(scroll, 1200);
      return () => {
        clearTimeout(t1);
        clearTimeout(t2);
      };
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <CurrencyProvider>
          <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/work" element={<WorkIndex />} />
            <Route path="/work/:slug" element={<WorkCategory />} />
            <Route path="/work/:slug/:artworkId" element={<ArtworkDetail />} />
            <Route path="/collections" element={<Collections />} />
            <Route path="/collections/:slug" element={<CollectionDetail />} />
            <Route path="/commissions" element={<Commissions />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/prints" element={<Prints />} />
            <Route path="/originals" element={<Originals />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/youth-art-classes" element={<YouthArtClasses />} />
            <Route path="/youth-art-classes/register" element={<YouthRegister />} />
            <Route path="/press" element={<Press />} />
            <Route path="/services" element={<Services />} />
            <Route path="/studio-visit" element={<StudioVisit />} />
            <Route path="/collectors" element={<Collectors />} />
            <Route path="/cv" element={<CVPage />} />
            <Route path="/books" element={<Books />} />
            <Route path="/murals" element={<Murals />} />
            <Route path="/paint-n-sip" element={<PaintNSip />} />
            <Route path="/live-painting" element={<LivePainting />} />
            <Route path="/trade" element={<Trade />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/journal/:slug" element={<JournalPost />} />
            <Route path="/checkout/success" element={<Navigate to="/prints" replace />} />
            <Route path="/purchase-original" element={<Navigate to="/originals" replace />} />
            {["black-western", "animals", "figurative-contemporary", "abstract-contemporary", "celebrity-interpretations", "small-works", "the-posse"].map((slug) => (
              <Route key={slug} path={`/${slug}`} element={<Navigate to={`/work/${slug}`} replace />} />
            ))}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
        </CurrencyProvider>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "hsl(0 0% 7%)",
              color: "hsl(38 25% 97%)",
              border: "none",
              borderRadius: 0,
              fontFamily: "Inter, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
